import React, { useState, useEffect } from "react";
import {
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Container,
  Typography,
  ImageList,
  ImageListItem,
} from "@mui/material";
import { GetToken } from "../../../../actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import api from "../../../../utils/apidsf";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import { CardActionArea } from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import axios from "../../../../utils/apidsf";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

// css
// import "./CreateUser.css";

const CreateUser = () => {
  const dispatch = useDispatch();
  const [notification, setnotification] = useState([]);
  useEffect(() => {
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    axios.get("/admin/notification", config).then((e) => {
      setnotification(e.data.data);
    });
    return () => {};
  }, []);
  console.log(notification);
  const deleteNotification = (id) => {
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const find = notification.filter((es) => {
      return es._id !== id;
    });
    // setsubjectlist(find);
    setnotification(find);
    console.log(find);

    axios.delete(`/admin/notification/${id.toString()}`, config).then((e) => {
      // setsubjectlist(e.data.Subject);
    });
  };
  return (
    <div className="admin__createUser">
      <Container style={{ margin: "50px", display: "flex", flexWrap: "wrap" }}>
        <h4 style={{ color: "black" }}>Notification list</h4>
        {/* {notification?.map((e) => {
          return (
            <Card sx={{ maxWidth: 345 }}>
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="/static/images/cards/contemplative-reptile.jpg"
                  alt="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Lizard
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Lizards are a widespread group of squamate reptiles, with
                    over 6,000 species, ranging across all continents except
                    Antarctica
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          );
        })} */}
      </Container>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          paddingLeft: "100px",
          paddingRight: "100px",
        }}
      >
        {notification.map((e, i) => {
          return (
            <Card key={i} sx={{ width: 250, marginX: 5, marginY: 2 }}>
              {/* <CardActionArea> */}
              <CardContent
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                <Typography gutterBottom variant="h6" component="div">
                  {e.title}
                </Typography>
                <Typography gutterBottom variant="" component="div">
                  {e.description}
                </Typography>
                <button style={{ border: "none", background: "none" }}>
                  <DeleteIcon
                    onClick={() => {
                      // deleteSubject(e);
                      deleteNotification(e._id);
                    }}
                    sx={{ justifyContent: "flex-end" }}
                  />
                </button>
                {/* {DeleteIcon} */}
              </CardContent>
              {/* </CardActionArea> */}
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default CreateUser;
